import React from "react";
import Seo from "../seo/Seo";

const Events = () => {
  return (
    <div className="container my-5">
      <Seo
        title="Eventos | Life Center"
        description="Eventos e iniciativas do Life Center."
        path="/eventos"
        noindex
      />
      <h1>Eventos</h1>
      <p>Em breve partilharemos aqui os próximos eventos do Life Center.</p>
    </div>
  );
};

export default Events;
